import { ref, isRef, Ref } from 'vue'
import { useQuery } from '@cqrs/vue-composables-cqrs'
import * as q from './queries-core'
export function useCurrentUserQueryV1(ensureGlobalAdminRole?: boolean | Ref<boolean>, ensureOrganizationAdminRole?: boolean | Ref<boolean>, ensureAnyAdminRole?: boolean | Ref<boolean>, ) {
	const _ensureGlobalAdminRole = isRef<boolean>(ensureGlobalAdminRole) ? ensureGlobalAdminRole : ref<boolean>(ensureGlobalAdminRole)
	const _ensureOrganizationAdminRole = isRef<boolean>(ensureOrganizationAdminRole) ? ensureOrganizationAdminRole : ref<boolean>(ensureOrganizationAdminRole)
	const _ensureAnyAdminRole = isRef<boolean>(ensureAnyAdminRole) ? ensureAnyAdminRole : ref<boolean>(ensureAnyAdminRole)
	const result = {
		ensureGlobalAdminRole: _ensureGlobalAdminRole,
		ensureOrganizationAdminRole: _ensureOrganizationAdminRole,
		ensureAnyAdminRole: _ensureAnyAdminRole,
		...useQuery(() => new q.CurrentUserQueryV1(_ensureGlobalAdminRole.value, _ensureOrganizationAdminRole.value, _ensureAnyAdminRole.value))
	}
	return {
		...result,
		runCurrentUserQueryV1: result.run,
		modelCurrentUserQueryV1: result.model,
	}
}

export function useOrganizationAdminCandidatesQueryV1(organizationUnitId?: number | Ref<number>, ) {
	const _organizationUnitId = isRef<number>(organizationUnitId) ? organizationUnitId : ref<number>(organizationUnitId)
	const result = {
		organizationUnitId: _organizationUnitId,
		...useQuery(() => new q.OrganizationAdminCandidatesQueryV1(_organizationUnitId.value))
	}
	return {
		...result,
		runOrganizationAdminCandidatesQueryV1: result.run,
		modelOrganizationAdminCandidatesQueryV1: result.model,
	}
}

export function usePasswordPolicyQueryV1() {
	const result = {
		...useQuery(() => new q.PasswordPolicyQueryV1())
	}
	return {
		...result,
		runPasswordPolicyQueryV1: result.run,
		modelPasswordPolicyQueryV1: result.model,
	}
}

export function useSearchAllUsersQueryV1(organizationUnitId?: number | Ref<number>, searchPhrase?: string | Ref<string>, includeActive?: boolean | Ref<boolean>, includeLocked?: boolean | Ref<boolean>, includeDeleted?: boolean | Ref<boolean>, includeServiceAccounts?: boolean | Ref<boolean>, ) {
	const _organizationUnitId = isRef<number>(organizationUnitId) ? organizationUnitId : ref<number>(organizationUnitId)
	const _searchPhrase = isRef<string>(searchPhrase) ? searchPhrase : ref<string>(searchPhrase)
	const _includeActive = isRef<boolean>(includeActive) ? includeActive : ref<boolean>(includeActive)
	const _includeLocked = isRef<boolean>(includeLocked) ? includeLocked : ref<boolean>(includeLocked)
	const _includeDeleted = isRef<boolean>(includeDeleted) ? includeDeleted : ref<boolean>(includeDeleted)
	const _includeServiceAccounts = isRef<boolean>(includeServiceAccounts) ? includeServiceAccounts : ref<boolean>(includeServiceAccounts)
	const result = {
		organizationUnitId: _organizationUnitId,
		searchPhrase: _searchPhrase,
		includeActive: _includeActive,
		includeLocked: _includeLocked,
		includeDeleted: _includeDeleted,
		includeServiceAccounts: _includeServiceAccounts,
		...useQuery(() => new q.SearchAllUsersQueryV1(_organizationUnitId.value, _searchPhrase.value, _includeActive.value, _includeLocked.value, _includeDeleted.value, _includeServiceAccounts.value))
	}
	return {
		...result,
		runSearchAllUsersQueryV1: result.run,
		modelSearchAllUsersQueryV1: result.model,
	}
}

export function useStartupDetailsQueryV1() {
	const result = {
		...useQuery(() => new q.StartupDetailsQueryV1())
	}
	return {
		...result,
		runStartupDetailsQueryV1: result.run,
		modelStartupDetailsQueryV1: result.model,
	}
}

export function useUserAccessRequestsQueryV1(organizationUnitId?: number | Ref<number>, includeRequested?: boolean | Ref<boolean>, includeRejected?: boolean | Ref<boolean>, ) {
	const _organizationUnitId = isRef<number>(organizationUnitId) ? organizationUnitId : ref<number>(organizationUnitId)
	const _includeRequested = isRef<boolean>(includeRequested) ? includeRequested : ref<boolean>(includeRequested)
	const _includeRejected = isRef<boolean>(includeRejected) ? includeRejected : ref<boolean>(includeRejected)
	const result = {
		organizationUnitId: _organizationUnitId,
		includeRequested: _includeRequested,
		includeRejected: _includeRejected,
		...useQuery(() => new q.UserAccessRequestsQueryV1(_organizationUnitId.value, _includeRequested.value, _includeRejected.value))
	}
	return {
		...result,
		runUserAccessRequestsQueryV1: result.run,
		modelUserAccessRequestsQueryV1: result.model,
	}
}

export function useUserDashboardQueryV1() {
	const result = {
		...useQuery(() => new q.UserDashboardQueryV1())
	}
	return {
		...result,
		runUserDashboardQueryV1: result.run,
		modelUserDashboardQueryV1: result.model,
	}
}

export function useUserQueryV1(userId?: string | Ref<string>, ) {
	const _userId = isRef<string>(userId) ? userId : ref<string>(userId)
	const result = {
		userId: _userId,
		...useQuery(() => new q.UserQueryV1(_userId.value))
	}
	return {
		...result,
		runUserQueryV1: result.run,
		modelUserQueryV1: result.model,
	}
}

